export const OPTIMIZE_FOR = {
  TIME: 'time',
  DISTANCE: 'distance',
} as const

export type OptimizeFor = typeof OPTIMIZE_FOR[keyof typeof OPTIMIZE_FOR]

export const ROAD_SIDE = {
  SAME_SIDE: 'sameSide',
  ANY: 'any',
} as const

export type RoadSide = typeof ROAD_SIDE[keyof typeof ROAD_SIDE]

/** Only what the submit accepts — a control the optimizer cannot act on does not belong here. */
export interface OptimizerSettings {
  readonly optimizeFor: OptimizeFor
  readonly avoidTolls: boolean
  readonly avoidHighways: boolean
  readonly roadSide: RoadSide
  readonly avoidUturns: boolean
  readonly avoidLeftTurns: boolean
  readonly avoidRightTurns: boolean
  readonly avoidSharpTurns: boolean
  readonly avoidServiceRoads: boolean
  /** Off by default: with no profile the vendor routes car-like, which is what most routes want. */
  readonly useTruckProfile: boolean
  // Feet and pounds at the call site, millimetres and kilograms on the wire — nobody types either.
  readonly truckHeightFt: number | ''
  readonly truckWidthFt: number | ''
  readonly truckLengthFt: number | ''
  readonly truckWeightLb: number | ''
}

export type OptimizerFormValues = OptimizerSettings

/** Read-only mirror of the truck config owned by Route & Truck details. */
export interface OptimizerCapacity {
  readonly truckName: string | null
  readonly load: number
  readonly capacityValue: number
  readonly capacityUnit: string
}

export interface OptimizationJob {
  readonly jobId: string
  readonly gridId: string
  readonly stopCount: number
  readonly startedAt: number
}
